export const DEFAULT_CONFIG = {
  width: 1920,
  height: 1152,
  gridSize: 192,
  rotationDeg: 0 as 0 | 90 | 180 | -90,
  animationSpeed: 0.8,
  sonarSpeed: 0.2,
  patternSeed: 0,
  exportFps: 60,
  exportFormat: 'mp4',
  showGrid: true,
  gridEvenOpacity: 97,
  gridOddOpacity: 85,
  patternType: "gradient",
  standardPatternType: "none",
  rampDirection: "horizontal" as "horizontal" | "vertical",
  backgroundColor: "#ff0000",
  showResolution: true,
  showLEDNumbers: true,
  showTechnicalDetails: true,
  showLogo: true,
  showSonar: true,
  sonarThickness: 4,
  sonarMode: false,
  showVisualEffects: true,
  showDefaultLogo: true,
  resolutionFontSize: 24,
  novaScreenConfigMode: false,
  novaShowArrows: true,
  novaShowLines: true,
  novaMinimalMode: false,
  ledWallMode: {
    enabled: true,
    columns: 10,
    rows: 6,
    panelWidth: 192,
    panelHeight: 192,
    borderWidth: 2
  },
  sonarRevealMode: true,
  allowFullscreenScroll: false,
  stretchFullscreen: false,
  gridOffset: {
    x: 0,
    y: 0
  },
  pixelMapMode: {
    enabled: false,
    mainScreenText: 'MAIN SCREEN',
    posX: 0,
    posY: 0,
    resW: 1920,
    resH: 1152,
    panelW: 192,
    panelH: 192,
    size: 1.0
  },
  enableAnamorphosis: false
} as const

export const MIN_COLUMNS_ROWS = 1
export const MAX_PIXELS = 8000 * 8000
